import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Checkbox from 'material-ui/Checkbox';
import Typography from 'material-ui/Typography';
import AddressItem from './AddressItem';
import { HouseListDirectory } from '../../constants/ComponentTypes';
import { Manager, Target, Popper } from 'react-popper';
import ClickAwayListener from 'material-ui/utils/ClickAwayListener';
import Collapse from 'material-ui/transitions/Collapse';
import { MenuItem, MenuList } from 'material-ui/Menu';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import Portal from 'material-ui/Portal';

const double = 2;
const styles = theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },

  item: {
    marginRight: theme.spacing.unit * double,
  },

  checkbox: {
    width: '20px',
    height: '20px',
  },

  coltwo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: '0 12px'
  },

  select: {
    border: 'none',
    fontSize: '13px'
  },

  paper: {
    maxHeight: 'unset'
  },

  flex: {
    flex: 1,
  },

  checkboxContainer: {
    padding: '20.5px',
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  popperClose: {
    pointerEvents: 'none',
  },

  dropdown: {
    margin: 12,
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    boxShadow: '0 4px 8px rgba(0,0,0,.12)',
  },

  menuItem: {
    fontSize: 13,
    borderBottom: '1px solid #D8DBDF',
    '&:hover': {
      backgroundColor: 'rgba(26,101,255,.05)',
    }
  },
});

class AddressTable extends React.Component {
  state = {
    open: false,
  }

  handleToggle = checked => () => {
    if (checked) {
      this.handleSelectAll(checked)();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  handleClose = event => {
    if (this.target.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleClick = (action) => {
    return () => {
      action();
      this.setState({ open: false });
    }
  }

  handleSelectAll = (indeterminate) => () => {
    let checked = indeterminate || this.props.isSelectAll;
    this.props.selectAll(!checked);
  }

  render() {
    const { classes, selectedItems, unselectedItems,
      filteredItems, isSelectAll, disabled, onTitleClicked,
      selectItem, onItemClicked, menuItems, type,
      onLabelClicked, totalCount, selectCount } = this.props;

    const { open } = this.state;

    let checked, indeterminate;

    if (isSelectAll) {
      checked = selectCount - unselectedItems.count() + selectedItems.count() > 0;
      indeterminate = (totalCount > selectCount - unselectedItems.count() + selectedItems.count());
    } else {
      checked = selectedItems.count() > 0;
      indeterminate = checked && totalCount > selectedItems.count();
    }

    if (filteredItems.length === 0) {
      return (
        <div style={this.props.style}>
          <div className={classes.row}>
            <Typography variant="subheading" style={{ color: '#71737B' }}>該当するアドレスはありません。</Typography>
          </div>
        </div>
      );
    } else {
      return (
        <div style={this.props.style}>
          <div className={classes.row} style={{ padding: 0 }}>
            <div className={classes.checkboxContainer}>
              <Manager>
                <Target>
                  <div ref={node => this.target = node}>
                    <Checkbox
                      aria-owns={open ? 'menu-list-collapse' : null}
                      aria-haspopup="true"
                      checked={checked}
                      onClick={this.handleToggle(checked)}
                      color="primary"
                      className={classes.checkbox}
                      indeterminate={indeterminate}
                    />
                  </div>
                </Target>
                <Portal>
                  <Popper
                    placement="bottom-start"
                    eventsEnabled={open}
                    className={classNames({ [classes.popperClose]: !open })}
                    style={{ zIndex: 2 }}
                  >
                    <ClickAwayListener onClickAway={this.handleClose}>
                      <Collapse in={open} id="menu-list-collapse" style={{ transformOrigin: '0 0 0' }}>
                        <div className={classes.dropdown}>
                          <MenuList role="menu" style={{ padding: 0 }}>
                            <MenuItem onClick={this.handleClick(this.handleSelectAll(indeterminate))} key={0} className={classes.menuItem}>全選択</MenuItem>
                            <MenuItem onClick={this.handleClick(() => this.props.toggleSelectOptionDialog())} key={1} className={classes.menuItem} style={{ border: 'none' }}>件数を指定して選択</MenuItem>
                          </MenuList>
                        </div>
                      </Collapse>
                    </ClickAwayListener>
                  </Popper>
                </Portal>
              </Manager>
            </div>

            <div className={classes.coltwo}>
              <div className={classes.flex}></div>

              {this.props.sortType && (<FormControl>
                <Select
                  value={this.props.sortType}
                  onChange={e => this.props.handleSortTypeChange(e.target.value)}
                  classes={{ select: classes.select }}
                  disableUnderline={true}
                  MenuProps={{
                    classes: {
                      paper: classes.paper,
                    }
                  }}
                >
                  {Object.values(this.props.sortTypes).map(item => (
                    <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                  ))}
                </Select>
              </FormControl>)}
            </div>

            {this.props.children}
          </div>

          {filteredItems.map((item, i) => {
            let checkedItem = false;

            if (isSelectAll) {
              checkedItem = i < selectCount;
            }

            if (checkedItem) {
              if (unselectedItems.has(item.id)) {
                checkedItem = false;
              }
            } else {
              if (selectedItems.has(item.id)) {
                checkedItem = true;
              }
            }

            return (
              <AddressItem
                key={i}
                index={i}
                checked={checkedItem ? true : false}
                item={item}
                onItemClicked={onItemClicked}
                onTitleClicked={onTitleClicked}
                selectItem={selectItem}
                type={type}
                menuItems={menuItems}
                onLabelClicked={onLabelClicked}
                disabled={disabled}
                isDemo={this.props.isDemo}
                togglePlanDialog={this.props.togglePlanDialog}
                user={this.props.user}
              />
            )
          })}
        </div>
      );
    }
  }
}

AddressTable.propTypes = {
  classes: PropTypes.object.isRequired,
  filteredItems: PropTypes.array,
  selectedItems: PropTypes.object,
  unselectedItems: PropTypes.object,
  isSelectAll: PropTypes.bool,
  totalCount: PropTypes.number,
  selectAll: PropTypes.func,
  selectItem: PropTypes.func,
  onItemClicked: PropTypes.func,
  type: PropTypes.string,
  menuItems: PropTypes.array.isRequired,
  onLabelClicked: PropTypes.func,
  disabled: PropTypes.bool,
  onTitleClicked: PropTypes.func,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortType: PropTypes.number,
  sortTypes: PropTypes.object,
  handleSortTypeChange: PropTypes.func,
  toggleSelectOptionDialog: PropTypes.func,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
  user: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.node,
};

AddressTable.defaultProps = {
  type: HouseListDirectory.MAIN.name,
}

export default withStyles(styles)(AddressTable);



// WEBPACK FOOTER //
// ./src/components/AddressBook/AddressTable.jsx